document.querySelectorAll('[data-pdp-main-product]').forEach((root) => {
  if (root.dataset.pdpReady) return;
  root.dataset.pdpReady = '1';

  const slides = [...root.querySelectorAll('[data-pdp-slide]')];
  const dots = [...root.querySelectorAll('[data-pdp-dot]')];
  const slider = root.querySelector('.pdp-main-product__mobile-slider');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let frame = 0;
  let track;

  root.querySelectorAll('[data-block-type="personalization"]').forEach((block) => {
    if (!block.querySelector('[data-pdp-personalization]')) block.hidden = true;
  });

  if (!document.getElementById('pdp-gallery-runtime-styles')) {
    const style = document.createElement('style');
    style.id = 'pdp-gallery-runtime-styles';
    style.textContent = '@media(max-width:989px){.pdp-main-product__mobile-slide{height:calc(102.925vw - 9.936px)!important}.pdp-main-product__mobile-slide .pdp-main-product__media-image,.pdp-main-product__mobile-slide .pdp-main-product__media-video,.pdp-main-product__mobile-slide .pdp-main-product__media-render iframe,.pdp-main-product__mobile-slide .pdp-main-product__media-render model-viewer{object-fit:cover!important}.pdp-main-product__arrow{display:grid!important;place-items:center;width:32px!important;height:32px!important;border:1px solid rgba(214,41,104,.22)!important;border-radius:999px!important;background:#fff7fa!important;color:var(--accent)!important;box-shadow:none!important;font-size:0!important;line-height:1!important;transition:transform .25s cubic-bezier(.22,1,.36,1),background-color .2s ease,border-color .2s ease!important}.pdp-main-product__arrow svg{display:block;width:18px;height:18px}.pdp-main-product__arrow--prev svg{transform:rotate(90deg)}.pdp-main-product__arrow--next svg{transform:rotate(-90deg)}.pdp-main-product__arrow:hover{border-color:rgba(214,41,104,.34)!important;background:#fff0f6!important}.pdp-main-product__arrow:active{transform:translateY(-50%) scale(.94)!important}.pdp-main-product__arrow:focus-visible{outline:3px solid rgba(214,41,104,.22)!important;outline-offset:3px!important}}@media(max-width:549px){.pdp-main-product__mobile-slide{height:calc(98.44vw - 8.501px)!important}}.pdp-main-product__accordion-icon{box-shadow:none!important}';
    document.head.appendChild(style);
  }

  if (slider && slides.length) {
    track = document.createElement('div');
    track.className = 'pdp-main-product__mobile-track';
    slider.insertBefore(track, slides[0]);
    slides.forEach((slide) => track.appendChild(slide));
    Object.assign(slider.style, { position: 'relative', overflow: 'hidden' });
    Object.assign(track.style, {
      display: 'flex',
      overflowX: 'auto',
      overflowY: 'hidden',
      scrollSnapType: 'x mandatory',
      scrollBehavior: reduced ? 'auto' : 'smooth',
      scrollbarWidth: 'none',
      WebkitOverflowScrolling: 'touch',
      touchAction: 'pan-x pan-y'
    });
    slides.forEach((slide) => Object.assign(slide.style, {
      display: 'block',
      flex: '0 0 100%',
      width: '100%',
      scrollSnapAlign: 'start',
      scrollSnapStop: 'always'
    }));
  }

  const initialiseLightbox = () => {
    const lightbox = root.querySelector('[data-pdp-reveal-lightbox]');
    const template = root.querySelector('[data-pdp-lightbox-template]');
    const content = root.querySelector('[data-pdp-lightbox-content]');
    const openButtons = [...root.querySelectorAll('[data-pdp-media-reveal]')];
    const closeButtons = [...root.querySelectorAll('[data-pdp-lightbox-close]')];

    if (!lightbox || !template || !content || !openButtons.length) return;

    let activeTrigger = null;
    let previousBodyOverflow = '';
    let preloadImage = null;
    let preloadVideo = null;
    let preconnectLink = null;

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const constrainedConnection = Boolean(
      connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')
    );

    const preconnect = (value) => {
      if (!value || preconnectLink) return;

      try {
        const origin = new URL(value, location.href).origin;
        if (origin === location.origin) return;

        preconnectLink = document.createElement('link');
        preconnectLink.rel = 'preconnect';
        preconnectLink.href = origin;
        preconnectLink.crossOrigin = 'anonymous';
        document.head.appendChild(preconnectLink);
      } catch (error) {
        preconnectLink = null;
      }
    };

    const prewarmMedia = (highPriority = false) => {
      const fragment = template.content.cloneNode(true);
      const sourceImage = fragment.querySelector('img');
      const sourceVideo = fragment.querySelector('video');
      const sourceIframe = fragment.querySelector('iframe');

      if (sourceImage) {
        const source = sourceImage.getAttribute('src') || sourceImage.src;
        const sourceSet = sourceImage.getAttribute('srcset');
        const sizes = sourceImage.getAttribute('sizes');

        if (!preloadImage) {
          preloadImage = new Image();
          preloadImage.decoding = 'async';
          if ('fetchPriority' in preloadImage) preloadImage.fetchPriority = highPriority ? 'high' : 'low';
          if (sizes) preloadImage.sizes = sizes;
          if (sourceSet) preloadImage.srcset = sourceSet;
          preloadImage.src = source;
          preloadImage.decode?.().catch(() => {});
        } else if (highPriority && 'fetchPriority' in preloadImage) {
          preloadImage.fetchPriority = 'high';
        }

        preconnect(source);
      }

      if (sourceVideo) {
        if (!preloadVideo) {
          preloadVideo = sourceVideo;
          preloadVideo.playsInline = true;
          preloadVideo.muted = true;
          preloadVideo.preload = highPriority ? 'auto' : 'metadata';
          preloadVideo.load();
        } else if (highPriority && preloadVideo.preload !== 'auto') {
          preloadVideo.preload = 'auto';
          preloadVideo.load();
        }

        const videoSource = preloadVideo.currentSrc || preloadVideo.src || preloadVideo.querySelector('source')?.src;
        preconnect(videoSource);
      }

      if (sourceIframe?.src) preconnect(sourceIframe.src);
    };

    const mountMedia = () => {
      if (!content.firstElementChild) {
        content.replaceChildren(template.content.cloneNode(true));
      }

      const image = content.querySelector('img');
      if (image) {
        image.loading = 'eager';
        image.decoding = 'async';
        if ('fetchPriority' in image) image.fetchPriority = 'high';
      }

      const video = content.querySelector('video');
      if (video) {
        video.playsInline = true;
        video.controls = true;
        video.preload = 'auto';
        video.load();
      }

      return { image, video, iframe: content.querySelector('iframe') };
    };

    const playMedia = ({ video, iframe }) => {
      if (video) {
        const start = () => {
          try {
            video.currentTime = 0;
          } catch (error) {
            // Metadata may not be ready yet; playback still begins as soon as possible.
          }
          video.play().catch(() => {});
        };

        if (video.readyState >= 2) {
          start();
        } else {
          video.addEventListener('canplay', start, { once: true });
        }
      }

      if (iframe?.src) {
        const source = new URL(iframe.src, location.href);
        source.searchParams.set('autoplay', '1');
        source.searchParams.set('playsinline', '1');
        iframe.src = source.toString();
      }
    };

    const openLightbox = (trigger) => {
      activeTrigger = trigger;
      const media = mountMedia();
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      playMedia(media);

      requestAnimationFrame(() => {
        lightbox.classList.add('is-open');
        lightbox.querySelector('.pdp-main-product__lightbox-close')?.focus({ preventScroll: true });
      });
    };

    const closeLightbox = () => {
      if (lightbox.hidden) return;

      content.querySelector('video')?.pause();
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousBodyOverflow;

      const finish = () => {
        lightbox.hidden = true;
        content.replaceChildren();
        activeTrigger?.focus({ preventScroll: true });
        activeTrigger = null;
      };

      if (reduced) {
        finish();
      } else {
        window.setTimeout(finish, 230);
      }
    };

    openButtons.forEach((button) => {
      button.addEventListener('pointerenter', () => prewarmMedia(true), { once: true, passive: true });
      button.addEventListener('focus', () => prewarmMedia(true), { once: true });
      button.addEventListener('pointerdown', () => {
        prewarmMedia(true);
        mountMedia();
      }, { passive: true });
      button.addEventListener('click', () => openLightbox(button));
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  };

  initialiseLightbox();

  const active = (nextIndex) => {
    index = Math.max(0, Math.min(nextIndex, slides.length - 1));
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  };

  const go = (nextIndex) => {
    if (!track || !slides.length) return;
    const normalised = (nextIndex + slides.length) % slides.length;
    track.scrollTo({ left: slides[normalised].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    active(normalised);
  };

  root.querySelector('[data-pdp-prev]')?.addEventListener('click', () => go(index - 1));
  root.querySelector('[data-pdp-next]')?.addEventListener('click', () => go(index + 1));
  dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.pdpDot) || 0)));

  track?.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => active(Math.round(track.scrollLeft / (track.clientWidth || 1))));
  }, { passive: true });

  root.querySelectorAll('[data-pdp-review-jump]').forEach((button) => button.addEventListener('click', () => {
    document.querySelector('.pdp-judgeme-reviews')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  root.querySelectorAll('[data-pdp-personalization]').forEach((button) => button.addEventListener('click', () => {
    const selected = !button.classList.contains('is-active');
    button.classList.toggle('is-active', selected);
    button.setAttribute('aria-pressed', selected);
    dispatchEvent(new CustomEvent('cardology:personalization-change', { detail: { selected } }));
  }));

  const accordions = [...root.querySelectorAll('.pdp-main-product__accordion details')];
  accordions.forEach((details) => details.addEventListener('toggle', () => {
    if (details.open) accordions.forEach((other) => { if (other !== details) other.open = false; });
  }));
});
